import { render, staticRenderFns } from "./TariffInfo.vue?vue&type=template&id=39186dc8&"
import script from "./TariffInfo.vue?vue&type=script&lang=js&"
export * from "./TariffInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports